import { LineItemStatus, PacingStatus } from '../../apis/graphql/types';
import { Option } from '../../components/types';
import { StatusColor } from './statusColor';

export const LINE_ITEM_STATUS_MAP = {
  APPROVED: StatusColor.GREEN,
  LIVE: StatusColor.GREEN,
  SUBMITTED: StatusColor.GREEN,
  NEEDS_AD: StatusColor.YELLOW,
  PAUSED: StatusColor.YELLOW,
  UNDER_REVIEW: StatusColor.BLUE,
  READY: StatusColor.BLUE,
  PROCESSING: StatusColor.BLUE,
  DRAFT: StatusColor.GRAY,
  COMPLETE: StatusColor.GRAY,
  PENDING_APPROVAL: StatusColor.GRAY,
  REJECTED: StatusColor.RED,
  SUSPENDED: StatusColor.RED,
  CANCELLED: StatusColor.RED,
  DELIVERED: StatusColor.GREEN,
  UNDERDELIVERED: StatusColor.GRAY,
};

type PacingStatusKeys = keyof typeof PacingStatus;
type PacingStatusValues = (typeof PacingStatus)[PacingStatusKeys];

export const PACING_STATUS_MAP: Record<PacingStatusValues, StatusColor> = {
  ON_PACING: StatusColor.GREEN,
  UNDER_PACING: StatusColor.RED,
  OVER_PACING: StatusColor.YELLOW,
};

export const LINE_ITEM_STATUS_OPTIONS: Option[] = [
  { value: LineItemStatus.Cancelled, label: 'Cancelled' },
  { value: LineItemStatus.Complete, label: 'Complete' },
  { value: LineItemStatus.Draft, label: 'Draft' },
  { value: LineItemStatus.Live, label: 'Live' },
  { value: LineItemStatus.Paused, label: 'Paused' },
  { value: LineItemStatus.PendingApproval, label: 'Pending Approval' },
  { value: LineItemStatus.Ready, label: 'Ready' },
  { value: LineItemStatus.Suspended, label: 'Suspended' },
];
